import { styled } from '../../Styles/stitches.config'

export const StyledPickerItem = styled('div', {
    display: 'grid',
    gap: '$1',
    gridAutoFlow: 'column',
    placeContent: 'center',
    textAlign: 'right',
    transition: '$default',
    userSelect: 'none',

    variants: {
        isSelected: {
            true: {
                color: '$primary600',
            },
        },
    },
})

export const StyledPickerItems = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',

    variants: {
        isMoving: {
            true: {
                cursor: 'grabbing',
            },
            false: {
                cursor: 'grab',
                transition: '$default',
            },
        },
    },
})

export const SelectedHighlight = styled('div', {
    borderBottom: '1px solid $primary200',
    borderTop: '1px solid $primary200',
    color: '$neutral400',
    display: 'grid',
    gridTemplateAreas: `'left right'`,
    gap: '$1',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr 1fr',
    placeContent: 'center',
    pointerEvents: 'none',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    zIndex: -1,
})

export const StyledPicker = styled('div', {
    display: 'grid',
    gridAutoFlow: 'column',
    overflow: 'hidden',
    position: 'relative',
    touchAction: 'none',

    '&:after, &:before': {
        content: '""',
        h: 50,
        pointerEvents: 'none',
        position: 'absolute',
        w: '100%',
        zIndex: 1,
    },

    '&:after': {
        linearGradient:
            '180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%',
        top: 0,
    },

    '&:before': {
        linearGradient:
            '0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%',
        bottom: 0,
    },
})
